const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// MLO photo URLs reuse the same path when a headshot is replaced, so we append
// a version stamp (derived from the stored file id) to bust client caches.
export function mloPhotoUrl(mlo, slot = "primary") {
  if (!mlo?.slug) return null;
  const secondary = slot === "secondary";
  const has = secondary ? mlo.has_photo_secondary : mlo.has_photo;
  if (!has) return null;
  const version =
    (secondary ? mlo.photo_secondary_version : mlo.photo_version) ||
    String(secondary ? mlo.photo_secondary_file_id : mlo.photo_file_id || "").slice(-8) ||
    "1";
  const path = secondary ? "photo/secondary" : "photo";
  return `${API}/mlos/${encodeURIComponent(mlo.slug)}/${path}?v=${version}`;
}
